import { useHistory } from "react-router-dom";
import { supportWidgetPaths } from "@/react/helpers/urlHelpers";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface PostBreadcrumbProps {
  spaceGroupName: string;
  spaceId: string;
  spaceName: string;
}

export const PostBreadcrumb = ({
  spaceGroupName,
  spaceName,
  spaceId,
}: PostBreadcrumbProps) => {
  const history = useHistory();

  const onSpaceClick = () => {
    history.push(supportWidgetPaths.posts(spaceId));
  };

  return (
    <div className="flex items-center">
      {spaceGroupName && (
        <>
          <div className="pr-1">
            <Typography.BodySm
              weight="regular"
              size="text-sm"
              color="text-tertiary"
            >
              {spaceGroupName}
            </Typography.BodySm>
          </div>
          <Typography.BodySm
            weight="regular"
            size="text-sm"
            color="text-tertiary"
          >
            {` / `}
          </Typography.BodySm>
        </>
      )}
      <button
        type="button"
        onClick={onSpaceClick}
        className="hover:bg-tertiary rounded-md pl-1 transition-colors duration-150 ease-linear"
      >
        <Typography.BodySm weight="regular" color="text-tertiary">
          {spaceName}
        </Typography.BodySm>
      </button>
    </div>
  );
};
